/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tracker_input_length_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the entered data. Tracker and metric names can have up to 100 characters; units can have up to 50 characters.`)
};

const pl_tracker_input_length_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź wprowadzone dane. Nazwy trackerów i metryk mogą mieć do 100 znaków, a jednostki do 50 znaków.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tracker_input_length_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tracker_input_length_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tracker_input_length_error", locale)
	if (locale === "en") return en_tracker_input_length_error(inputs)
	return pl_tracker_input_length_error(inputs)
};